import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  caption?: string;
  actions?: ReactNode;
}

/** Screen header: big serifless h1, muted caption, actions on the right. */
export function PageHeader({ title, caption, actions }: PageHeaderProps) {
  return (
    <header className="rfp-page-head">
      <div className="rfp-page-head__titles">
        <h1>{title}</h1>
        {caption && <p className="rfp-page-head__caption">{caption}</p>}
      </div>
      {actions && <div className="rfp-page-head__actions">{actions}</div>}
    </header>
  );
}
